export class ClientNoteModel {
  readonly id: number;
  readonly note: string;
  readonly createdAt: Date;
  readonly author: ClientNoteAuthorModel;
  readonly attachments: ClientNoteAttachmentModel[];
}

export class ClientNoteAuthorModel {
  readonly userId: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly profilePictureUrl: string;
}

export class ClientNoteAttachmentModel {
  readonly id: number;
  readonly fileName: string;
  readonly url: string;
}
